import { practicesLocationsGroupedOptions } from "../../../../../lib/systemData";
import CustomSelectGroupedMultiple from "../../../../common/interactive/CustomSelectGroupedMultiple";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { filterActions } from "../../../../../store/filter";
import { removeStorageItem } from "../../../../../lib/script";
import Button from "../../../../common/Button";
import { workqueueActions } from "../../../../../store/workqueue";
import { setFiltersInLocalStorage } from "../../../../../lib/filters";

export default function PoliceReportsWorkQFitlers({workQ}) {
    const dispatch = useDispatch()
    const reduxFilters = useSelector(state => state.filter.filters)
    const draftRef = useRef(false)
    const [filtersValues, setFiltersValues] = useState(null)

    useEffect(() => {
        if (draftRef.current) {
            return
        }
        if (Array.isArray(reduxFilters?.location) && reduxFilters.location.length) {
            setFiltersValues(reduxFilters)
        } else {
            setFiltersValues(current => current ? null : current)
        }
    }, [reduxFilters])

    function mainSelectAction(value) {
        draftRef.current = true
        let updateobject = {
            ...filtersValues
        }     
        let update = JSON.parse(JSON.stringify(updateobject))

        //need to expand the object and include name of the selected options!
        if (value?.data?.value?.constructor == Array) { // check if array
            
            update[value.identifier.type] = value.data.value

        } else {
            update[value.identifier.type] = value.data.value

            if (value.identifier.type == 'do_not_lien') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            if (value.identifier.type == 'ihc_review') {
                update[value.identifier.type] = value.data.value ? 1 : 0
            }
            
        }

        if (value.identifier.type == 'payer_type') { // if it is payer_type reset the payer status!!!!
            update.payer_status = null
        }

        setFiltersValues(update)
    }

    async function setFiltersHandler() {
        draftRef.current = false
        dispatch(filterActions.setFiltersMultiple(filtersValues))
        dispatch(workqueueActions.setRefreshApi()) //filters do not refresh the api anymore!!!1
        
        //add the filters in local storage for persistent filtering after refresh
        setFiltersInLocalStorage(filtersValues, workQ?.slug)

    }

    function clearAllFiltersHandler() {
        draftRef.current = false
        dispatch(filterActions.setFiltersMultiple({}))
        dispatch(workqueueActions.setRefreshApi()) //filters do not refresh the api anymore!!!1

        setFiltersValues(null)
        // remove the local storage if any 
        removeStorageItem(workQ?.slug)

    }

    return <>
    {/* clinics  */}        
    <CustomSelectGroupedMultiple label={"Clinic"} optionsData={practicesLocationsGroupedOptions()} preSelectedValue={filtersValues?.location} action={mainSelectAction} name={'location'} identifier={{type: 'location'}}/>

    <Button click={clearAllFiltersHandler} btnStyle={'btn_white'}>Clear All Filters</Button>
    <Button click={setFiltersHandler}>Set Filters</Button>
</>
}